import script from "./BasicData.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicData.vue?vue&type=script&setup=true&lang=js"

import "./BasicData.vue?vue&type=style&index=0&id=e05bad18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e05bad18"]])

export default __exports__